export default __webpack_public_path__ + "static/media/img13.8b02bf18.PNG";